import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { ProjectModule } from "@/store/modules/project.module";
import simplebar from "simplebar-vue";
import Switches from "vue-switches";
import EcGrid from "@/components/widgets/EcGrid.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
import projectsMachine from "./machines/projectsMachine";
import { interpret } from "xstate";
import { PMOProjectModel } from "@/store/models/project/PMOProject";
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let Projects = /** @class */ (() => {
    let Projects = class Projects extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Projects";
            this.searchKey = "";
            this.showWatchListsProject = false;
            this.newProject = new PMOProjectModel();
            this.isPageDirty = false;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "PMO",
                    href: "#",
                },
                {
                    text: "Projects",
                    active: true,
                },
            ];
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.initialSortBy = {
                field: "name",
                type: "asc",
            };
            this.columns = [
                {
                    field: "name",
                    label: "Project Name",
                    tdClass: "project-name",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Project Name",
                    },
                },
                {
                    field: "owner",
                    label: "Owner",
                    tdClass: "project-Owner",
                    thClass: "project-Owner",
                    sortable: false,
                },
                {
                    field: "members",
                    label: "Members",
                    tdClass: "project-member",
                    sortable: false,
                },
                {
                    field: "tags",
                    label: "Tags",
                    tdClass: "project-tags",
                    sortable: false,
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "project-action",
                    tdClass: "project-action",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "name",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            this.totalCount = 0;
            this.machine = projectsMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        // METHODS
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            filters.push({
                name: "watchLists",
                value: `${this.showWatchListsProject}`,
            });
            var searchData = {
                //gridOption: {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            ProjectModule.AssignSearchParams(searchData);
            this.machineService.send({
                type: "GETTING_PROJECTS",
                searchData: searchData,
            });
        }
        clearFilter() {
            this.showWatchListsProject = false;
            this.serverParams.columnFilters = {};
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        showProjectDeleteModal(projectId) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            this.projectId = projectId;
            this.machineService.send({ type: "DELETE_PROJECT", ispageChanged: isPageChanged });
        }
        deleteProject() {
            this.machineService.send({ type: "DELETING_PROJECT", projectId: this.projectId });
            this.loadItems();
        }
        cancelProject() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        GetWatchListedProjects() {
            this.initialPage = 1;
            this.serverParams.page = this.initialPage;
            this.loadItems();
        }
        showAddProject() {
            this.newProject.name = null;
            this.newProject.description = null;
            this.machineService.send({ type: "ADD_PROJECT" });
        }
        saveProject() {
            this.validate("createProjectObserver").then((response) => {
                if (response) {
                    this.machineService.send({
                        type: "ADDING_PROJECT",
                        project: this.newProject,
                    });
                }
            });
        }
        closeModal() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        onRowClick(params) {
            this.$router.push({ name: "ProjectOverview", params: { projectId: params.row.id } });
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "ProjectOverview") {
                ProjectModule.ClearSearchParams();
            }
            next();
        }
        initialize() {
            var value = ProjectModule.searchParams;
            if (value != null) {
                this.isPageDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                var watchLists = value.columnFilters.filter((item) => item.name == "watchLists");
                value.columnFilters = value.columnFilters.filter((item) => item.name != "watchLists");
                if (value.columnFilters.length > 0) {
                    value.columnFilters.forEach((item) => {
                        this.serverParams.columnFilters[item.name] = item.value;
                    });
                }
                this.showWatchListsProject = JSON.parse(watchLists[0].value.toLowerCase());
                this.initialSortBy = value.sort;
            }
        }
        assignColumnFilters() {
            var ecgrid = this.$refs.ecgrid;
            var gridColumns = ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters;
            if (this.gridParams && this.gridParams.columnFilters.length > 0) {
                this.gridParams.columnFilters.forEach((item) => {
                    this.isPageDirty = true;
                    gridColumns[item.name] = item.value;
                });
            }
        }
        //Computed
        get rows() {
            return ProjectModule.projectGridViewEntries;
        }
        get gridParams() {
            return ProjectModule.searchParams;
        }
        get totalProjects() {
            return ProjectModule.totalProjects;
        }
        get projectGridViewEntries() {
            return ProjectModule.projectGridViewEntries;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (previousState.matches("idle") && this.state.matches("gettingProjects")) {
                    this.assignColumnFilters();
                }
                if (this.state.matches("addProject")) {
                    this.$bvModal.show("add-project");
                }
                if (this.state.matches("loadedProjects")) {
                    this.$bvModal.hide("add-project");
                    this.totalCount = this.totalProjects;
                    this.isGridLoading = false;
                    this.isPageDirty = false;
                }
                if (this.state.matches("gettingProjects") && previousState.matches("deletingProject")) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    Projects = __decorate([
        Component({
            name: "Projects",
            components: {
                Loader,
                Layout,
                PageHeader,
                simplebar,
                EcGrid,
                DeleteComponent,
                Switches,
            },
        })
    ], Projects);
    return Projects;
})();
export default Projects;
